// MMT2 Reports - Two Paired Auth Aggregate tables (Agg1 & Agg2)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { Refresh, AccessTime } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { getMmt2Agg1DetailsData, getMmt2Agg2DetailsData, clearData } from '../../Redux/MMTReports/MMT2Slice';
import { Mmt2Agg1Columns, Mmt2Agg2Columns } from '../../Table/TableColumn';
import ReportsTable from '../../Table/ReportsTable';
import Spinner from '../../Spinner/Spinner';
import { triggerDatabricksJobData } from '../../Redux/DataBricks/MMTDataBricksSlice';

function MMT2() {
    const dispatch = useDispatch();
    // const agg1Data = useSelector(state => state.mmt2.agg1Data.data);
    // const agg2Data = useSelector(state => state.mmt2.agg2Data.data);
    const agg1Loading = useSelector(state => state.mmt2.agg1Data.loading);
    const agg2Loading = useSelector(state => state.mmt2.agg2Data.loading);
    const agg1Error = useSelector(state => state.mmt2.agg1Data.error);
    const agg2Error = useSelector(state => state.mmt2.agg2Data.error);
    const agg1LastRefreshed = useSelector(state => state.mmt2.agg1Data.lastRefreshedDate);
    const agg2LastRefreshed = useSelector(state => state.mmt2.agg2Data.lastRefreshedDate);
    const [initialFetchDone, setInitialFetchDone] = useState(false);
    // Track if a manual refresh has been initiated so we suppress the global spinner (pattern similar to MMT3)

    useEffect(() => {
        if ((agg1Error || agg2Error)) {
            toast.error('Error loading MMT2 data');
        }
    }, [agg1Error, agg2Error]);

    useEffect(() => {
        // Always clear and refetch on mount (tab revisit)
        dispatch(clearData());
        Promise.all([
            dispatch(getMmt2Agg1DetailsData()),
            dispatch(getMmt2Agg2DetailsData())
        ]).finally(() => setInitialFetchDone(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRefreshAgg1 = () => {
        dispatch(getMmt2Agg1DetailsData());
    };
    const handleRefreshAgg2 = () => {
        dispatch(getMmt2Agg2DetailsData());
    };

    const handleRunJob = async () => {
        try {
            const action = await dispatch(triggerDatabricksJobData(1));
            if (triggerDatabricksJobData.fulfilled.match(action)) {
                toast.success(`Databricks job started (Run ID: ${action.payload.runId || 'N/A'})`);
            } else if (triggerDatabricksJobData.rejected.match(action)) {
                toast.error(action.payload || 'Failed to start Databricks job');
            }
        }
        catch (error) {
            toast.error('Failed to trigger Databricks job');
            console.error('Error triggering Databricks job:', error);
        }
    };

    return (
        <>
            {/* Show full-page spinner only during the initial combined load. Individual table refreshes should not hide the other table. */}
            {!initialFetchDone && <Spinner />}
            <Box sx={{ margin: '20px 0' }}>
                <Button variant="contained" color="primary" onClick={handleRunJob}>Start New Run</Button>
            </Box>
            {/* Agg1 Table */}
            <Box sx={{ paddingBottom: '16px', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Button variant="outlined" size="small" disabled startIcon={<AccessTime />} sx={{ minWidth: '150px', fontWeight: 'bold' }}>
                    {`Last Updated: ${agg1LastRefreshed ? agg1LastRefreshed.split('.')[0] : ''}`}
                </Button>
                <Button variant="outlined" size="small" onClick={handleRefreshAgg1} disabled={agg1Loading} startIcon={<Refresh />} sx={{ minWidth: '120px', fontWeight: 'bold' }}>
                    {agg1Loading ? 'Refreshing...' : 'Refresh'}
                </Button>
            </Box>
            <ReportsTable tableName={'Paired Auth Agg1'} tableIndex={0} columns={Mmt2Agg1Columns} dataSource={'agg1Data'} loading={agg1Loading} sliceName={'mmt2'} />
            {/* Agg2 Table */}
            <Box sx={{ paddingBottom: '16px', paddingTop: '40px', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Button variant="outlined" size="small" disabled startIcon={<AccessTime />} sx={{ minWidth: '150px', fontWeight: 'bold' }}>
                    {`Last Updated: ${agg2LastRefreshed ? agg2LastRefreshed.split('.')[0] : ''}`}
                </Button>
                <Button variant="outlined" size="small" onClick={handleRefreshAgg2} disabled={agg2Loading} startIcon={<Refresh />} sx={{ minWidth: '120px', fontWeight: 'bold' }}>
                    {agg2Loading ? 'Refreshing...' : 'Refresh'}
                </Button>
            </Box>
            <ReportsTable tableName={'Paired Auth Agg2'} tableIndex={1} columns={Mmt2Agg2Columns} dataSource={'agg2Data'} loading={agg2Loading} sliceName={'mmt2'} />
        </>
    );
}

export default MMT2;
